import { useMemo } from 'react';
import "./Tour.css";
import Overlay from "../common/Overlay";
import { sortObjectsByName } from "../utils/sortObjectsByName";

// Component for listing all available tours

function TourDropdown({ tours, onSelect, onClose, style }) {

  const sortedTours = useMemo(() => {
    return sortObjectsByName([...tours]);
  }, [tours]);

  return (
    <Overlay
      onClose={onClose}
      darkBackground={false}
    >
      <div className="TourDropdown" style={style}>
        <h1>Verfügbare Touren</h1>
        <div className="TourList">
          {sortedTours.map((tour) => (
            <div key={tour.id} className="TourItem" onClick={() => { onSelect(tour); onClose(); }}>
              <span className="TourItem-name">{tour.name}</span>
            </div>
          ))}
        </div>
      </div>
    </Overlay>
  );
}

export default TourDropdown;